module.exports = "/assets/js/aae5228a727094edccf9ac0d9ba00841.svg";